<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>，即可进入【医生工作室】，在顶部菜单栏中点击<span
            class="orange">【预约管理】</span>
        </p>
        <img src="../../../assets/img/docAppointRes_a.png" alt="">
        <p><strong>第二步：</strong>在【预约管理】列表中，找到需要调整预约时间的预约，点击<span class="orange">【修改预约】</span>的按钮，弹出【修改预约】弹窗
        </p>
        <img src="../../../assets/doctorImg/appointment_a.png" alt="" height="259">
        <p><strong>第三步：</strong>在【修改预约】弹窗中</p>
        <p>
          ① 重新选择预约时间<br/>
          ② 选择性地在输入框中输入修改预约的理由<br/>
          ③ 点击<span class="orange">【提交】</span>按钮，即可向用户提交申请，等待用户进行审批<br/>
          ④ 用户审批完成后，可在【系统通知】中查看
        </p>
        <img src="../../../assets/doctorImg/appointment_b.png" alt="" height="785">
      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh">
          <p><strong>第一步：</strong>在【预约列表】中，选择某一预约条目</p>
          <p><strong>第二步：</strong>点击页面中<span class="orange">【修改预约】</span>按钮</p>
          <p><strong>第三步：</strong>在【修改预约】弹窗中，重新选择时间，填写修改理由，并点击<span class="orange">【确认】</span>按钮</p>
        </div>
        <img src="../../../assets/doctorImg/editAppointmentPhone.png" alt="" >
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "appointment",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
